import React from 'react';
// import { Link } from "react-router-dom";
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// @material-ui/icons

// core components
import Header from '../../components/Header/Header.jsx';
import Footer from '../../components/Footer/Footer.jsx';
import GridContainer from '../../components/Grid/GridContainer.jsx';
import GridItem from '../../components/Grid/GridItem.jsx';
// import Button from "../../components/CustomButtons/Button.jsx";
import HeaderLinks from '../../components/Header/HeaderLinks.jsx';
import Parallax from '../../components/Parallax/Parallax.jsx';

import landingPageStyle from '../../assets/jss/material-kit-react/views/landingPage.jsx';

// Sections for this page
import ProductSection from './Sections/ProductSection.jsx';
import './LandingPage.css';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { history } from 'utils/hist';
import obj from './script';

// console.log(obj.one.second.third());

//import {EndUser} from './eusign'
//const EndUser = require('./eusign')
// const EndUser = window.EndUser

const dashboardRoutes = [];

class LandingPage extends React.Component {
  componentDidMount() {
    // var euSign = new EndUser(
    //   "sign-widget-parent", /* Ідентифікатор батківського елементу */
    //   "sign-widget", /* Ідентифікатор елементу iframe */
    //   "https://eu.iit.com.ua/sign-widget/v20190411/",
    //   /* URI для завантаження iframe */
    //   EndUser.FormType.SignFile /* Тип форми iframe */
    //   );

    if (this.props.auth.isAuthenticated) {
      history.push('/profile-page');
    }
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand={'govUa'}
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 150,
            color: 'white'
          }}
          {...rest}
        />
        <Parallax filter>
          <div className={classes.container}>
            <GridContainer className="landingPage">
              <GridItem xs={12} sm={12} md={6} className="ml-5 ml-md-3">
                <h1 className={classes.title}>Електронна послуга</h1>
                <h4>Допомога на дітей фізичним особам-підприємцям</h4>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} className="mt-3 ml-5 ml-md-3">
                <h5 className="text-warning bold">
                Постанова Кабінету Міністрів України від 25.11.2020 року № 1171 передбачає завершення програми щодо виплати з 16 грудня 2020 року допомоги на дітей фізичним особам - підприємцям
                </h5>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <ProductSection />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

LandingPage.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    auth: state.auth
  };
};

export default connect(mapStateToProps)(
  withStyles(landingPageStyle)(LandingPage)
);
